import emptyCadastroBase from './emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'AREAS_PATRIMONIAIS'
  },
  json: {
    cadastrante: {
      oficio: null,
      solicitacao: null,
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          matricula: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null
        },
        telefones: []
      },
      documentos: []
    },
    interessado: {
      prefeito: {
        isPrefeito: true,
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null
        },
        telefones: []
      },
      pessoa: {
        tipo: 'PJ',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null
        },
        telefones: []
      },
      documentos: []
    },
    georreferenciamento: {
      localizacoes: [],
      documentos: [],
      denominacao: '',
      possuiGeorreferenciamento: '',
      responsavel: {
        nome: '',
        codigoIncra: '',
        creaRnp: '',
        formacao: '',
        codigoCredenciamento: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptyAreasPatrimoniais.js